import type { PayloadAction } from '@reduxjs/toolkit';
import { createReducer } from '@reduxjs/toolkit';
import changeSocketState from 'actions/socketState';

type SocketState = 'connecting' | 'connected' | 'disconnected';

type EntityState = {
  state: SocketState;
};

const defaultState: EntityState = {
  state: 'disconnected',
};

type SocketStateReducer<P = void> = (state: EntityState, payload: PayloadAction<P>) => EntityState;

const handleInitAgentSessionRequest: SocketStateReducer<SocketState> = (state, { payload }) => ({
  ...state,
  state: payload,
});

const handlers = {
  [changeSocketState.toString()]: handleInitAgentSessionRequest,
};

const socketStateReducer = createReducer(defaultState, handlers);

export default socketStateReducer;
